import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../store';
import { UserRole, UserType } from '../models/user';

const useGetUserRole = (options?: { skip?: boolean }): UserRole => {
  const { business_id: businessId } = useParams();
  if (options?.skip) {
    return UserRole.USER;
  }
  if (!businessId || !businessId) {
    throw new Error('no business_id');
  }
  const { user: userData } = useSelector(
    (state: RootState) => state.auth,
  );
  try {
    return userData.type === UserType.ROOT ? UserRole.ROOT : userData.user_businesses.find((ub) => ub.business_id === businessId)?.permissions || UserRole.SCANNER;
  } catch (error) {
    console.error(error);
    return UserRole.USER;
  }
};

export default useGetUserRole;
